import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css'

import 'github-markdown-css'

import '@/styles/index.scss'

import App from './App.vue'
import store from './store'
import router from './router'
import { SpmPlugin } from '@/utils/spm'

const app = createApp(App)

app.config.globalProperties.$ELEMENT = {
  size: Cookies.get('size') || 'medium',
  locale: zhCn
}

app.use(ElementPlus, {
  size: Cookies.get('size') || 'medium',
  locale: zhCn
})

app.use(store)
app.use(router)
app.use(SpmPlugin)

app.mount('#app')
